import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import type { SignInPageProps } from '@backstage/core-plugin-api';
import { GitHubSignIn } from './GitHubSignIn';

export const SnapSignIn = (props: SignInPageProps) => {
  const config = useApi(configApiRef);
  return config.getOptionalString('app.portalMode') === 'shared' ? (
    <GitHubSignIn {...props} />
  ) : (
    <SignInPage {...props} providers={['guest']} />
  );
};
export const snapSignInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: { loader: async () => props => <SnapSignIn {...props} /> },
    }),
  ],
});
